"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathCase = void 0;
var tslib_1 = require("tslib");
var dot_case_1 = require("dot-case");
function pathCase(input, options) {
    if (options === void 0) { options = {}; }
    return dot_case_1.dotCase(input, tslib_1.__assign({ delimiter: "/" }, options));
}
exports.pathCase = pathCase;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/path-case/dist/index.js
// module id = 1390
// module chunks = 0